import { useQuery } from "@tanstack/react-query";

export const useVersionCheck = (intervalMs = 5000) => {
  const { data: version } = useQuery({
    queryKey: ["version"],
    queryFn: async () => {
      const response = await fetch("/version.json");
      const { version } = (await response.json()) as { version: string };
      return version;
    },
    refetchInterval: intervalMs,
    retry: true,
  });

  return version;
};
